module.exports = __webpack_public_path__ + "img/share-dark.e2213a01.svg";